/**
 * @generated SignedSource<<87cbbf2209822b5dcc8ae9faa4c3f1c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemIntegrationsToggleSyncMutation$variables = {
  syncEnabled: boolean;
};
export type ActionItemIntegrationsToggleSyncMutation$data = {
  readonly toggleUserIntegrationSync: {
    readonly viewer: {
      readonly integrations: {
        readonly userLevelActionItemIntegration: {
          readonly syncEnabled: boolean | null;
        } | null;
      };
    } | null;
  } | null;
};
export type ActionItemIntegrationsToggleSyncMutation = {
  response: ActionItemIntegrationsToggleSyncMutation$data;
  variables: ActionItemIntegrationsToggleSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "syncEnabled"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "syncEnabled",
        "variableName": "syncEnabled"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemIntegrationsToggleSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleUserIntegrationSyncPayload",
        "kind": "LinkedField",
        "name": "toggleUserIntegrationSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionItemIntegrationNode",
                    "kind": "LinkedField",
                    "name": "userLevelActionItemIntegration",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemIntegrationsToggleSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleUserIntegrationSyncPayload",
        "kind": "LinkedField",
        "name": "toggleUserIntegrationSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionItemIntegrationNode",
                    "kind": "LinkedField",
                    "name": "userLevelActionItemIntegration",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d726487ff6093e345524ec4957823fa6",
    "id": null,
    "metadata": {},
    "name": "ActionItemIntegrationsToggleSyncMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemIntegrationsToggleSyncMutation(\n  $syncEnabled: Boolean!\n) {\n  toggleUserIntegrationSync(input: {syncEnabled: $syncEnabled}) {\n    viewer {\n      integrations {\n        userLevelActionItemIntegration {\n          syncEnabled\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2363de556c80833d145823b875b30104";

export default node;
